export const DictionaryActionTypes = {
  GET_DICTIONARIES: undefined,
  GET_DICTIONARIES_SUCCESS: undefined,
};
